/*
  import { insuranceList } from '@/services/Units/Tabs/Insurance/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import _get from 'lodash/get'

import { notifyProblem, notifyError, notifyMessage } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await insuranceList.dispatch ('getInsuranceList', {
      hoaId
    });
  */
  async getInsuranceList({}, { hoaID, ownerID }) {
    console.log('in getInsuranceList...')
    try {
      const result = await kms.get('/OwnerInsurance/OwnerInsurance/List', {
        params: {
          hoaID,
          ownerID
        }
      })

      if (isDebug == true) console.debug('getInsuranceList log=' + JSON.stringify(result))

      return {
        list: result.results
      }
    } catch (exception) {
      notifyProblem(`The insurance list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  async getUnitById({}, { unitID }) {
    try {
      console.debug('in getUnitById...')
      const result = await kms.get(`/Roster/Unit/${unitID}`)

      if (isDebug == true) console.debug('getUnitById=' + JSON.stringify(result))

      return {
        result: result
      }
    } catch (exception) {
      notifyProblem(`There was a problem retrieving this unit.`)
      console.error(exception)
    }

    return {
      result: {}
    }
  },

  async deleteInsurance({ dispatch }, { ownerInsuranceID, done }) {
    try {
      const path = `/OwnerInsurance/OwnerInsurance/${ownerInsuranceID}?forceDelete=false`

      const results = await kms.delete(path)

      if (this.isDebug == true) console.debug('results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      const wasDeleted = _get(results, 'deleted', false)

      if (wasDeleted === true) {
        notifyMessage(`Successfully deleted the selected insurance.`)
        done()
      } else {
        notifyError('There was a problem deleting the selected insurance.')
      }
    } catch (exception) {
      notifyProblem(`There was a problem deleting the selected insurance.`)
      console.error(exception)
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const insuranceList = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
